<div
  [formGroup]="formGroup"
  class="form-field"
  [ngClass]="{
    'form-field--error': error,
    'form-field--no-overflow': tootipInfo
  }"
>
  <ion-item
    [ngClass]="{ required: required, 'custom-icon-select': type === 'select',
    'valid': formControl.valid && (formControl.dirty || formControl.touched) && type === 'selectwithsearch' }"
    lines="none"
    class="ion-no-margin ion-no-padding"
    popoverWidth
  >
    <ion-label position="stacked" class="form-field__label" [for]="formControlName"
      >{{ label | translate }}
      @if(required) {
      <span> * </span>
      } @if(tootipInfo) {
      <span
        class="form-field__tooltip icon-question-circle"
        [attr.data-tooltip]="tootipInfo | translate"
      ></span>

      }
    </ion-label>
    @switch (type) {
     @case ('selectwithsearch') {
    <ion-input
    [id]="formControlName"
      class="form-field__input"
      singleSpace
      readonly
      [value]="displayValue"
      [attr.required]="required ? '' : null"
      (ionFocus)="onFocusInput(); openCustomPopover($event)"
      (ionBlur)="onBlurInput()"
    >

      <span
    class="icon-SMALL-ARROW-DOWN"
    slot="end"
  ></span>
    </ion-input>
    }
      @case ('select') {
    <ion-select
      class="form-field__input"
      [id]="formControlName"
      [formControlName]="formControlName"
      interface="popover"
      alignment="center"
      [fill]="true"
      mode="md"
      (ionFocus)="onFocusInput()"
      (ionBlur)="onBlurInput()"
    >
      <span
        class="icon icon-SMALL-ARROW-DOWN form-field__input-icon"
        slot="end"
      ></span>
      @if (defaultValueSelect) {
      <ion-select-option
        class="background-hover-grey"
        [value]="defaultValueSelect.value"
        >{{ defaultValueSelect.label }}</ion-select-option
      >
      } @for (option of options; track $index) {
      <ion-select-option class="background-hover-grey" [value]="option.value">{{
        option.label | translate
      }}</ion-select-option>
      }
    </ion-select>
    } @case ('text-area') {
    <ion-textarea
      class="form-field__textarea"
      [id]="formControlName"
      [formControlName]="formControlName"
      singleSpace
      [maxlength]="maxLength"
      [attr.required]="required ? '' : null"
      [autoGrow]="true"
    ></ion-textarea>
    } @default { @if (type === 'password' || type === 'passwordText' || type === 'email') {
    <ion-input
    #inputElement
    [id]="formControlName"
      [attr.autocomplete]="'new-password'"
      [attr.autocorrect]="'off'"
      [attr.spellcheck]="'false'"
      class="form-field__input"
      [type]="type"
      singleSpace
      [formControlName]="formControlName"
      [maxlength]="maxLength"
      [attr.required]="required ? '' : null"
      (ionChange)="onInputChange()"
      (keydown)="blockCopyPaste($event)"
      (paste)="blockCopyCutPaste($event)"
      (copy)="blockCopyCutPaste($event)"
      (cut)="blockCopyCutPaste($event)"
    >
    </ion-input>
    } @else {
    <ion-input
    #inputElement
    [id]="formControlName"
      [attr.autocomplete]="'new-password'"
      [attr.autocorrect]="'off'"
      [attr.spellcheck]="'false'"
      class="form-field__input"
      [type]="type"
      singleSpace
      [formControlName]="formControlName"
      [maxlength]="maxLength"
      [attr.required]="required ? '' : null"
      (ionChange)="onInputChange()"
    >
    </ion-input>
    } } }
  </ion-item>
  @if(error) {
  <div class="form-field__error">
    @if(error.mustMatch && (type === 'password' || type === 'passwordText')) {
    <span class="form-field__error-message">{{
      'error.password-mismatch' | translate
    }}</span>
    } @else if(error.mustMatch && type !== 'password' && type !== 'passwordText') {
    <span class="form-field__error-message">{{
      'error.mail-mismatch' | translate
    }}</span>
    } @else if(error.pattern && (type === 'password' || type === 'passwordText')) {
    <span class="form-field__error-message">{{
      'error.password' | translate
    }}</span>
    } @else if(error.pattern && type !== 'password' && type !== 'passwordText') {
    <span class="form-field__error-message">{{
      'error.format' | translate : { field: label | translate }
    }}</span>
    } @else if(error.required) {
    <span class="form-field__error-message">{{
      'error.required' | translate : { field: label | translate }
    }}</span>
    } @else if(error.wrongValue) {
      <span class="form-field__error-message">{{
        'error.wrong-mail' | translate : { field: label | translate }
      }}</span>
    } @else if(error.minlength) {
    <span class="form-field__error-message">config minlength</span>
    }
  </div>
  }
</div>
